var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{opacity:.35;}.c,.d{isolation:isolate;}.e{fill:#fff;}.f{fill:#185abd;}.d{opacity:.2;}.g{fill:url(#b);}.h{fill:#2b7cd3;}.i{fill:#103f91;}.j{fill:#41a5ee;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2.13,
    y1: -746.94,
    x2: 10.15,
    y2: -733.06,
    gradientTransform: "translate(0 752)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2368c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1a5dbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146ac"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M22.98,.84H6.6c-.57,0-1.02,.46-1.02,1.02h0V6.42l9.49,2.79,8.93-2.79V1.86c0-.57-.46-1.02-1.02-1.02h0Z",
    style: {
      fill: "#41a5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6.42H5.58v5.58l9.49,1.67,8.93-1.67V6.42Z",
    style: {
      fill: "#2b7cd3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58,12v5.58l8.93,1.12,9.49-1.12v-5.58H5.58Z",
    style: {
      fill: "#185abd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,23.16H22.98c.57,0,1.02-.46,1.02-1.02h0v-4.56H5.58v4.56c0,.57,.46,1.02,1.02,1.02h0Z",
    style: {
      fill: "#103f91"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.81,5.86H5.58v12.84h6.23c.56,0,1.02-.46,1.02-1.02V6.88c0-.56-.46-1.02-1.02-1.02Z",
    style: {
      isolation: "isolate",
      opacity: 0.35
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.26,5.86H5.58v12.84h5.67c.56,0,1.02-.46,1.02-1.02V6.88c0-.56-.46-1.02-1.02-1.02Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02,5.86H11.26c.57,0,1.02,.46,1.02,1.02v10.23c0,.57-.46,1.02-1.02,1.02H1.02c-.57,0-1.02-.46-1.02-1.02V6.88c0-.57,.46-1.02,1.02-1.02Z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,13.71c.02,.16,.03,.3,.04,.41h.02c0-.11,.03-.25,.06-.4,.03-.16,.05-.29,.08-.4l1.08-4.64h1.39l1.12,4.57c.06,.28,.11,.57,.14,.86h.02c.02-.28,.06-.56,.12-.84l.89-4.6h1.27l-1.56,6.65h-1.48l-1.06-4.41c-.03-.13-.07-.29-.1-.5s-.06-.35-.07-.45h-.02c-.01,.11-.04,.27-.07,.48-.04,.21-.06,.37-.09,.47l-1,4.39h-1.5l-1.57-6.65h1.29l.97,4.65c.02,.1,.04,.22,.06,.38Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.3e764c3ca7edfa58dba12633a9fcc196.svg";
export { ForwardRef as ReactComponent };